import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { ArticlePayload } from 'STORE/Messages/Message/Payload/ArticlePayload/ArticlePayload';

export async function updateArticle(
  groupId: string,
  messageId: string,
  payload: ArticlePayload
): Promise<void> {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return;
  }

  const message = group.messagesStore.getMessageById(messageId);
  if (!message) {
    return;
  }

  const canEdit = Tasks.messaging.canSendMessage({ groupId, isNewMessage: false, payload });
  if (!canEdit.result) {
    canEdit.error && Tasks.app.showToast(canEdit.error);
    return;
  }

  message.payload = payload;
  await Tasks.messaging.editMessage(message);
}
